/**
 * @generated SignedSource<<2250972624c1b3c35997b8acf46815e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicYouMayLikeWidgetArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "topicYouMayLikeWidgetArticle";
};
export type topicYouMayLikeWidgetArticle$key = {
  readonly " $data"?: topicYouMayLikeWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicYouMayLikeWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicYouMayLikeWidgetArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "a7a466b09a12a815fd7b07234ba7765c";

export default node;
